import { useContext } from "react";
import { ModalSettingContext } from "../../index";
import { InputWhite } from "@UI/New/InputWhite";
import s from './index.module.css';

export const Name = () => {
    const { state, setFieldInState } = useContext(ModalSettingContext);

    return (
        <InputWhite 
            value={state.name}
            placeholder='Название встречи'
            onChange={value => setFieldInState({field: 'name', value})}
            className={s.input}
        />
    )
}